export const menuData = [
  {title: "Para Criadores", link: "/creators"},
  {title: "Para Fãs", link: "/followers"},
  {title: "FAQ", link: "/faq"},
  {title: "Contato", link: "mailto:ajuda@privetly.com"},
]